"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function startOfWeekMonday(d) {
    const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = x.getDay();
    const diff = day === 0 ? -6 : 1 - day;
    x.setDate(x.getDate() + diff);
    x.setHours(0, 0, 0, 0);
    return x;
}
function dayKey(dt) {
    return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}
const WEEKDAY_LABELS = ['S', 'M', 'T', 'W', 'T', 'F', 'S']; // indexed by Date#getDay() (0 = Sunday)
/**
 * Read-only date-range overview: event counts per day + ghost booking on its day.
 * Defaults to a Monday-aligned 7-day week; pass dayCount/alignToWeekStart for other ranges.
 * Used by shop booking preview and Mango Personal (shared-ui).
 */
const CalendarWeekStrip = ({ anchorDate, events, ghost, selectedDayKey, className, dayCount = 7, alignToWeekStart = true, onSelectDay, }) => {
    const days = (0, react_1.useMemo)(() => {
        const start = alignToWeekStart
            ? startOfWeekMonday(anchorDate)
            : new Date(anchorDate.getFullYear(), anchorDate.getMonth(), anchorDate.getDate());
        return Array.from({ length: dayCount }, (_, i) => {
            const dt = new Date(start);
            dt.setDate(start.getDate() + i);
            return dt;
        });
    }, [anchorDate, dayCount, alignToWeekStart]);
    const counts = (0, react_1.useMemo)(() => {
        const m = new Map();
        for (const e of events) {
            const d = new Date(e.startTime);
            const k = dayKey(d);
            m.set(k, (m.get(k) || 0) + 1);
        }
        return m;
    }, [events]);
    const ghostDay = ghost?.startTime &&
        (() => {
            try {
                return dayKey(new Date(ghost.startTime));
            }
            catch {
                return null;
            }
        })();
    return ((0, jsx_runtime_1.jsx)("div", { className: className, style: {
            display: 'flex',
            gap: 6,
            fontSize: 12,
            marginTop: 8,
            overflowX: dayCount > 7 ? 'auto' : 'visible',
            paddingBottom: dayCount > 7 ? 4 : 0,
        }, role: "list", "aria-label": "Date range overview", children: days.map((dt) => {
            const k = dayKey(dt);
            const n = counts.get(k) || 0;
            const isSel = selectedDayKey === k;
            const hasGhost = ghostDay === k;
            return ((0, jsx_runtime_1.jsxs)("div", { role: "listitem", onClick: onSelectDay ? () => onSelectDay(k) : undefined, style: {
                    flex: dayCount > 7 ? '0 0 46px' : '1 1 0',
                    textAlign: 'center',
                    padding: '6px 4px',
                    borderRadius: 8,
                    border: `2px solid ${isSel ? '#10b981' : 'rgba(16, 185, 129, 0.35)'}`,
                    background: hasGhost ? 'rgba(139, 92, 246, 0.25)' : 'rgba(0,0,0,0.2)',
                    color: '#e5e7eb',
                    cursor: onSelectDay ? 'pointer' : 'default',
                }, children: [(0, jsx_runtime_1.jsx)("div", { style: { fontWeight: 700, color: '#4ade80' }, children: WEEKDAY_LABELS[dt.getDay()] }), (0, jsx_runtime_1.jsx)("div", { style: { fontSize: 11, opacity: 0.9 }, children: dt.getDate() }), (0, jsx_runtime_1.jsxs)("div", { style: { fontSize: 10, marginTop: 4 }, children: [n > 0 ? `${n} event${n === 1 ? '' : 's'}` : '—', hasGhost && ((0, jsx_runtime_1.jsx)("div", { style: { color: '#c4b5fd', marginTop: 2 }, children: "+ proposed" }))] })] }, k));
        }) }));
};
exports.default = CalendarWeekStrip;
